(() => {
  angular
    .module('complianceFrameworkApp.core')
    .filter('normalizeMessageType', normalizeMessageType);

  function normalizeMessageType() {
    return input => {
      if (input != null) {
        switch (input) {
        case 'ad_review':
          return 'Ad Review';
        case 'policy_review':
          return 'Policy Review';
        case 'website_review':
          return 'Website Review';
        case 'resource_request':
          return 'Resource Request';
        case 'talk_request':
          return 'Request to Talk';
        case 'compliance_question':
          return 'Compliance Question';
        case 'other_request':
          return 'Other Request';
        case 'disclosure_review':
          return 'Disclosure Review';
        }
      }
    };
  }
})();
